export class Socialusers {
    provider: string | undefined;
    id: string | undefined;
    email: string | undefined;
    name: string | undefined;
    photoUrl: string | undefined;
    token?: string;
    idToken?: string;
  }
  